import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { SuspenseWrapper } from 'components/containers';

const DetailDependentLazy = lazy(() =>
  import(/* webpackChunkName: "detail-dependent" */ 'pages').then(({ DetailDependent }) => ({
    default: DetailDependent,
  })),
);

const TimelineDependentLazy = lazy(() =>
  import(/* webpackChunkName: "timeline-dependent" */ 'pages').then(({ TimelineDependent }) => ({
    default: TimelineDependent,
  })),
);

const parent = '/dependents/:id/';

export const DependentRouter = () => (
  <Switch>
    <Redirect exact from={parent} to={`${parent}timeline`} />
    <Route path={`${parent}timeline`}>
      <SuspenseWrapper>
        <TimelineDependentLazy />
      </SuspenseWrapper>
    </Route>
    <Route path={`${parent}details`}>
      <SuspenseWrapper>
        <DetailDependentLazy />
      </SuspenseWrapper>
    </Route>
  </Switch>
);
